import { Dispatch, SetStateAction } from 'react';
import { ChildCareAgeGroups } from '@/__generated__/globalTypes';
import { MultiSelectPills } from '../../MultiSelectPills';

interface ChildAgeRangesProps {
  childCareAgeGroupsList: ChildCareAgeGroups[];
  setChildCareAgeGroupsList: Dispatch<SetStateAction<ChildCareAgeGroups[]>>;
}

const ChildAgeRanges = ({
  childCareAgeGroupsList,
  setChildCareAgeGroupsList,
}: ChildAgeRangesProps) => {
  const childCareAgeRangeList = [
    { label: '0 - 11 months', value: ChildCareAgeGroups.NEWBORN },
    { label: '1 - 3 yrs', value: ChildCareAgeGroups.TODDLER },
    { label: '4 - 5 yrs', value: ChildCareAgeGroups.EARLY_SCHOOL },
    { label: '6 - 11 yrs', value: ChildCareAgeGroups.ELEMENTARY_SCHOOL },
    { label: '12+ yrs', value: ChildCareAgeGroups.TEEN },
  ];

  const handleOnChangeEvent = (values: ChildCareAgeGroups[]) => {
    setChildCareAgeGroupsList(values);
  };

  return (
    <MultiSelectPills
      sectionName="Child age ranges"
      handleOnChangeEvent={handleOnChangeEvent}
      pillOptions={childCareAgeRangeList}
      category="CHILD_AGE_RANGES"
      selectedValues={childCareAgeGroupsList}
    />
  );
};

export { ChildAgeRanges };
